import type { ResolvedInstallationOrder } from "../types/installation";
import {
  applyInstallationResolveResponse,
  type ApplyInstallationResolveOptions,
  type ApplyInstallationResolveResult,
  type InstallationResolveFormikSync,
} from "./applyInstallationResolveResponse";

export type ApplyInstallationEditResolveOptions = ApplyInstallationResolveOptions & {
  /** Agent/Realtor edit forms use `specialFees`; signage uses `specialfee`. */
  feesFieldName?: "specialfee" | "specialFees";
};

/**
 * Apply resolve response on installation edit/view pages (TaxEngine replacement).
 * Syncs product subtotal + optional alternate special-fee field name.
 */
export function applyInstallationEditResolveResponse(
  resolved: ResolvedInstallationOrder,
  formik: InstallationResolveFormikSync,
  fallbackInstallationSubtotal: number,
  options?: ApplyInstallationEditResolveOptions
): ApplyInstallationResolveResult {
  const result = applyInstallationResolveResponse(
    resolved,
    formik,
    fallbackInstallationSubtotal,
    options
  );

  const feesField = options?.feesFieldName ?? "specialfee";
  if (feesField !== "specialfee") {
    formik.setFieldValue(feesField, result.mergedFees, false);
  }

  const lineItems = Array.isArray(resolved.line_items) ? resolved.line_items : [];
  const productSubtotal = lineItems.reduce(
    (s, li) =>
      s +
      Number(
        li.item_sub_total ??
          Number(li.changed_unit_price ?? li.unit_price ?? 0) * Number(li.quantity ?? 0)
      ),
    0
  );
  formik.setFieldValue("totals.product_subtotal", Math.round(productSubtotal * 100) / 100, false);

  if (resolved.cart_id) {
    formik.setFieldValue("totals.cart_id", String(resolved.cart_id), false);
  }

  return result;
}
